import berckley from '#app/assets/images/logos/berckley-logo.png'
import cooperacionLogo from '#app/assets/images/logos/cooperacion-logo.png'
import cooperacion from '#app/assets/images/logos/cooperacion.svg'
import exppel from '#app/assets/images/logos/exppel.svg'
import hdim from '#app/assets/images/logos/hdim.svg'
import hipotecario from '#app/assets/images/logos/hipotecario-logo.png'
import laSegunda from '#app/assets/images/logos/la-segunda-logo.png'
import nacionSeguros from '#app/assets/images/logos/nacion-seguros-logo.png'
import nogalDeCuyo from '#app/assets/images/logos/nogal-de-cuyo.svg'
import rivadavia from '#app/assets/images/logos/rivadavia-logo.png'
import serena from '#app/assets/images/logos/serena-logo.png'
import wolko from '#app/assets/images/logos/wolko.svg'

export const alianzaLogos = [
	{
		src: hdim,
		alt: 'HDIM',
		href: '#',
		width: 120,
		height: 60,
	},
	{
		src: exppel,
		alt: 'Exppel',
		href: '#',
		width: 80,
		height: 40,
	},
	{
		src: nogalDeCuyo,
		alt: 'Nogal de Cuyo',
		href: '#',
		width: 246,
		height: 25,
	},
	{
		src: wolko,
		alt: 'Wolko',
		href: '#',
		width: 133,
		height: 35,
	},
	{
		src: cooperacion,
		alt: 'Cooperación',
		href: '#',
		width: 300,
		height: 100,
	},
	{
		src: berckley,
		alt: 'Berckley',
		href: '#',
		width: 152, // ratio 3.4:1 (1280x378)
		height: 45,
	},
	{
		src: cooperacionLogo,
		alt: 'Cooperación Seguros',
		href: '#',
		width: 89, // ratio 1.8:1 (299x168)
		height: 50,
	},
	{
		src: hipotecario,
		alt: 'Hipotecario Seguros',
		href: '#',
		width: 125, // ratio 3.1:1 (288x92)
		height: 40,
	},
	{
		src: laSegunda,
		alt: 'La Segunda',
		href: '#',
		width: 127, // ratio 2.8:1 (850x300)
		height: 45,
	},
	{
		src: nacionSeguros,
		alt: 'Nación Seguros',
		href: '#',
		width: 175, // ratio 5:1 (1000x200)
		height: 35,
	},
	{
		src: rivadavia,
		alt: 'Rivadavia Seguros',
		href: '#',
		width: 52, // ratio 1.3:1 (1024x767) - casi cuadrado
		height: 40,
	},
	{
		src: serena,
		alt: 'Serena',
		href: '#',
		width: 55, // ratio 1:1 (225x225) - cuadrado
		height: 55,
	},
]
